export default "__VITE_PUBLIC_ASSET__665fca68__"